import { ReactNode } from 'react';
import H1 from './H1';
import H2 from './H2';
import H3 from './H3';
import H4 from './H4';
import H5 from './H5';

type HeadingPriority = 'H1' | 'H2' | 'H3' | 'H4' | 'H5';

interface HeadingProps {
  size: HeadingPriority;
  label: string;
  className?: string;
  children?: ReactNode;
}

function Heading({ className, label, size = 'H1' }: HeadingProps) {
  const HeadingSizes = {
    H1: H1,
    H2: H2,
    H3: H3,
    H4: H4,
    H5: H5,
  };

  const Tag = HeadingSizes[size];

  return <Tag className={className}>{label}</Tag>;
}
export default Heading;
